import { useAsync, useAsyncCallback } from 'react-async-hook';
import NotificationsAPI from 'services/API/NotificationsAPI';

export const useNotificationSettings = (userId: string) => {
  const asyncState = useAsync(async () => {
    const response = await NotificationsAPI.getNotificationSettings(userId);

    return response;
  }, [userId]);

  return asyncState;
};
export const useToggleProjectGroupEnabled = (userId: string) => {
  const asyncAction = useAsyncCallback(async (enabled: boolean) => {
    const response = await NotificationsAPI.postNotificationSettings(userId, {
      project_group_enabled: enabled,
    });

    return response;
  });

  return asyncAction;
};
